import { supabase } from "./supabase";
// import { getStoriesFromCache } from '@/utils/query-cache-utils';
import { Entity } from "@/services/supabase/entities";
// import { Chapter } from "@/services/supabase/chapters";
// import { MindMap } from "@/services/supabase/mind-maps";
import { NoteFolder } from "@/services/supabase/notes";

// Cache constants - these are now only used for backward compatibility
// The actual caching is handled by TanStack Query
// Cache constants - these are now only used for backward compatibility
// The actual caching is handled by TanStack Query
// const NAV_ITEMS_CACHE_PREFIX = 'nav_items_';

// Interface for the navigation structure
export interface NavigationItems {
  folders: Partial<NoteFolder>[];
  entities: Partial<Entity>[];
}

/**
 * Get all navigation items for a project in a single request
 * This function consolidates multiple API calls into a single request
 *
 * @param projectId - Project ID
 * @returns Promise with navigation items structure
 */
export const getNavItems = async (projectId: string | number): Promise<NavigationItems> => {
  console.log('Fetching navigation items for project', projectId);

  try {
    // First, get the current story ID for the project
    const { data: projectData, error: projectError } = await supabase
      .from('projects')
      .select('current_story_id')
      .eq('id', projectId)
      .single();

    if (projectError) {
      console.error('Error fetching project:', projectError);
      throw projectError;
    }

    const currentStoryId = projectData?.current_story_id;
    console.log('Current story ID for project:', currentStoryId);

    // Fetch folders for this project
    const { data: foldersData, error: foldersError } = await supabase
      .from('note_folders')
      .select('id, name, created_at')
      .eq('project_id', projectId)
      .order('name');

    if (foldersError) {
      console.error('Error fetching folders:', foldersError);
      throw foldersError;
    }

    // Simplified: No longer fetching stories here as they are not returned in the NavItems interface
    // and were only acting as a side-effect cache warmer.

    // We no longer fetch chapters here - they will be loaded on demand when the dropdown is opened

    // Fetch entities for the project
    const { data: entitiesData, error: entitiesError } = await supabase
      .from('entities')
      .select('id, name, created_at')
      .eq('project_id', projectId)
      .order('name');

    if (entitiesError) {
      console.error('Error fetching entities:', entitiesError);
      throw entitiesError;
    }

    // We no longer fetch mind maps here - they will be loaded on demand when the dropdown is opened

    // Build the navigation items object
    const navItems: NavigationItems = {
      folders: foldersData || [],
      entities: entitiesData || [],
    };

    return navItems;
  } catch (error) {
    console.error('Error in getNavItems:', error);
    throw error;
  }
};

/**
 * Clear the navigation items cache for a project
 * Call this when any of the navigation items change
 *
 * Note: This function is now just a placeholder for backward compatibility.
 * The actual cache invalidation is handled by TanStack Query.
 *
 * @param projectId - Project ID
 */
export const clearNavItemsCache = (projectId: string | number): void => {
  console.log(`Clearing navigation cache for project ${projectId}`);
  // No-op - TanStack Query handles cache invalidation
};